module.exports = "<div id=\"loading\">\n  <ng2-slim-loading-bar [color]=\"'red'\" [height]=\"'3px'\"></ng2-slim-loading-bar>\n</div>\n\n\n  <alert></alert>\n<router-outlet></router-outlet>  \n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.html
// module id = ./src/app/main/main.component.html
// module chunks = main